import React, { useEffect, useState } from "react";
import SecureLS from "secure-ls";
import { encrypt } from "../../utils/cipher.js";
import LoginBg from "../../images/Group 342829.png";
import "./Otp.css";
import TopBar from "../DashBoardLayout/TopBar";
import { Button } from "@mui/material";
import Footer from "../DashBoardLayout/Footer.jsx";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loader from "../utils/Loader/Loader.js";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const Otp = () => {
  var ls = new SecureLS();
  const [otpValue, setOtpValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const token = ls.get("loginToken");
  const pwdReset = ls.get("pwdReset");
  const [resendOTP, setResendOTP] = useState(true);
  const [timerOTP, setTimerOTP] = useState(true);
  const [Minutes, setMinutes] = useState("05");
  const [Seconds, setSeconds] = useState("00");
  const email = useSelector((state) => {
    return state.loginDetails.loginEmail;
  });
  const password = useSelector((state) => state.loginDetails.loginPassword);

 
  const resetTime=()=>{
    setMinutes("05");
    setSeconds("00");
  }
  useEffect(() => {
    if (resendOTP) {
      let minutes = Number(Minutes),seconds = Number(Seconds);
      let IntervalId = setInterval(() => {
        seconds -= 1;
        if (seconds == -1 && minutes > 0) {
          minutes -= 1;
          seconds = 59;
          setMinutes(minutes < 10 ? "0" + minutes : minutes);
        } else if (seconds == 0 && minutes == 0) {
          setTimerOTP(false);
          setResendOTP(false);
          clearInterval(IntervalId);
        }
        setSeconds(seconds < 10 ? "0" + seconds : seconds);
      }, 1000);
    }
  }, [resendOTP]);
  const handleOtp = () => {
    if (otpValue.length == 6) {
      if (!isNaN(otpValue.trim())) {
        const payload = {
          otp: otpValue.trim(),
          token: token,
        };
        setIsLoading(true);
        let encryptedPayload = encrypt(payload);
        console.log("Verifying OTP");
        axios
          .post(`${process.env.REACT_APP_BACKEND_URL}/verifyOTP`, {
            payload: encryptedPayload,
          })
          .then((res) => {
            console.log("Response from OTP API");
            if (res?.data?.loginSuccess) {
              ls.set("isUserLoggedIn", true);
              ls.set("token", res?.data?.token);
              ls.set("fname", res?.data?.user?.firstName);
              ls.set("lname", res?.data?.user?.lastName);
              ls.set("phno", res?.data?.user?.phNumber);
              ls.set("userType", res?.data?.user?.userType);
              ls.set("userEmail", res?.data?.user?.email);
              navigate("/app/daily");
              setIsLoading(false);
              if (pwdReset <= 10) {
                Swal.fire({
                  // iconHtml: `<img src=${infoImage} />`,
                  icon: "info",
                  confirmButtonColor: "#1d2c47",
                  customClass: {
                    // icon: "no-border",
                    confirmButton: "custom-padding no-focus",
                  },
                  text: `Password will expire in ${pwdReset} days`,
                  showCancelButton: true,
                  confirmButtonText: "Reset Password",
                  cancelButtonText: "Ignore",
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.href = `${process.env.REACT_APP_IDM_URL}/ForgotPassword/`;
                  }
                });
              }
            } else {
              Swal.fire({
                title: "Error",
                text: `${res.data.message}`,
                icon: "error",
                confirmButtonText: "Retry",
                confirmButtonColor: "#1C81C4",
              });
              setIsLoading(false);
              navigate("/");
            }
          })
          .catch((err) => {
            console.log("Error in tryCatch OTP--", err);
            ls.clear();
            navigate("/");
            setIsLoading(false);
          });
      } else {
        Swal.fire({
          title: "Error",
          text: "Opps! Please Enter Numbers only",
          icon: "error",
        });
        setOtpValue(null);
      }
    } else {
      Swal.fire({
        title: "Error",
        text: "Opps! Please Enter only 6 charcters",
        icon: "error",
      });
      setOtpValue(null);
    }
  };

  const handleResend = () => {
    console.log("Resending OTP");

    const payload = {
      email: email.toLowerCase(),
      password: password,
    };

    let encryptedPayload = encrypt(payload);
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/login`, {
        payload: encryptedPayload,
      })
      .then((res) => {
        if (
          res.data["message"] == "Login Successful" &&
          res.data["success"] == true
        ) {
          console.log("OTP Sent");
          Swal.fire({
            title: "Success",
            text: `OTP Sent`,
            icon: "success",
          });
          ls.set("loginToken", res.data.token);
          setResendOTP(true);
          resetTime();
        } else {
          Swal.fire({
            title: "Error",
            text: `${res?.data?.message}`,
            icon: "error",
            confirmButtonText: "Retry",
            confirmButtonColor: "#1C81C4",
          });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error in Login---", err);
        Swal.fire({
          title: "Error",
          text: `${err}`,
          icon: "error",
          confirmButtonText: "Retry",
          confirmButtonColor: "#1C81C4",
        });
        setIsLoading(false);
        return;
      });
  };

  return (
    <>
      <div className="Login" style={{ margin: "4.2rem 0 0 0" }}>
        <TopBar />
        <div className="LoginBody">
          <div className="LoginBody_one">
            <p
              style={{
                color: "#1C81C4",
                fontWeight: "600",
                fontSize: "1.4rem",
                textAlign: "center",
                marginBottom: "2rem",
              }}
            >
              Welcome to KFintech
            </p>

            <div className="OuterInput">
              <div className="inputfields">
                <for>Enter OTP</for>
                <input
                  className="verifyOtpBtn"
                  placeholder="Enter 6-digit OTP"
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  pattern="\d{6}"
                  required
                  onChange={(e) => setOtpValue(e.target.value)}
                ></input>
              </div>

              <Button
                variant="outlined"
                className="otp-btn"
                disabled={isLoading}
                onClick={handleOtp}
                sx={{ color: `${isLoading ? "#000 !important" : "#1C81C4"}` }}
              >
                {isLoading ? "Verifying..." : "Verify OTP"}
                {isLoading && <Loader color="#000" />}
              </Button>

              <div>{`${Minutes} : ${Seconds}`}</div>
            </div>
            <p
              style={{
                fontWeight: "bold",
                color: "#484848",
                textAlign: "center",
              }}
            >
              Didn't receive OTP?{" "}
              <Button
                // variant="outlined"
                className="reset-otp-btn"
                disabled={resendOTP}
                onClick={handleResend}
                sx={{
                  fontFamily: "Poppins",
                  border: "none",
                  color: "#1C81C4",
                }}
              >
                Resend OTP
              </Button>
            </p>
          </div>
          <hr
            style={{
              height: "40rem",
              marginTop: "1rem",
              color: "rgb(158, 154, 154)",
              opacity: "0.4",
              border: "1px solid rgb(158, 154, 154)",
            }}
            className="line"
          ></hr>

          <div className="LoginBody_two">
            <img src={LoginBg} style={{ height: "77vh" }}></img>
          </div>
        </div>

        <div style={{ marginTop: "0.8rem" }}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Otp;
